import React from 'react'
import Header from "../Header/Header"
import TransformationMain from './TransformationMain'



const TransformationBody = () => {
  return (
    <div>
       <Header title="Transformation Projects" />
       <TransformationMain />
    </div>
  )
}

export default TransformationBody
